<template>
  <q-page class="flex flex-center">
    <AccountAuthenticationForm />
  </q-page>
</template>

<script>
import { mapGetters } from 'vuex';
import AccountAuthenticationForm from 'components/account/AuthenticationForm';

export default {
  components: { AccountAuthenticationForm },
  computed: {
    ...mapGetters('account', ['isAuthenticated']),
  },
  mounted() {
    // Redirect to Institutions if user is already logged in
    if (this.isAuthenticated) {
      // eslint-disable-next-line no-unused-vars
      this.$router.replace({ name: 'InstitutionIndex' }).catch((error) => {});
    }
  },
};
</script>
